import { useStore } from '@/store';
import { getSupportedMetricsApiRequest } from '@/services/api/report-api';

export const refreshSupportedMetricsApiRequest = async (): Promise<unknown[]> => {
  const store = useStore();
  const payload = await getSupportedMetricsApiRequest();
  store.setMetrics(payload as string[]);
  return payload;
};
